import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { RequirementDefinitionsApiListRequirementDefinitionsRequest } from "@wingspanhq/wingspan-api-sdk";
// Imported from the registry module, NOT the `@query` barrel — this hook sits
// inside the barrel's import graph (via the registry's invalidation keys), so
// a barrel import here closes a module cycle.
import { queriesRequirementDefinitions } from "../../../v3/query/queriesRequirementDefinitions";
import { useQueryRequirementDefinitionsSettings } from "./useQueryRequirementDefinitionsSettings";
import { ExtendedRequirementDefinition } from "./useQueryExtendedRequirementDefinition";
import { QUERY_EXTENDED_REQUIREMENT_DEFINITIONS } from "../keys";

export { QUERY_EXTENDED_REQUIREMENT_DEFINITIONS };

export const useQueryExtendedRequirementDefinitions = (
  fetch: Parameters<typeof useQueryRequirementDefinitionsSettings>[0]["fetch"],
  request?: RequirementDefinitionsApiListRequirementDefinitionsRequest
) => {
  const queryRequirements =
    queriesRequirementDefinitions.listRequirementDefinitions.useQueryAll(
      request
    );
  const querySettings = useQueryRequirementDefinitionsSettings({
    enabled: queryRequirements.isSuccess,
    requirementDefinitions: queryRequirements.flatData ?? [],
    fetch
  });

  return useWSQuery<ExtendedRequirementDefinition[], WSServiceError>(
    [
      QUERY_EXTENDED_REQUIREMENT_DEFINITIONS,
      fetch,
      queryRequirements.dataUpdatedAt
    ],
    () => {
      const requirements = queryRequirements.flatData ?? [];
      const extendedRequirements = requirements.map(requirement => ({
        ...requirement,
        dataSourceSettings: querySettings.data?.[requirement.dataSourceId!]
      }));

      return Promise.resolve(extendedRequirements);
    },
    {
      enabled: queryRequirements.isSuccess && querySettings.isFetched
    }
  );
};
